import { Check, Clock, FileText } from 'lucide-react'

import { Badge } from '@/components/ui/badge'

type Status = 'ready' | 'processing' | 'draft'

interface StatusBadgeProps {
  status: Status
  label?: string
  showIcon?: boolean
  size?: 'sm' | 'default'
}

const statusConfig = {
  ready: {
    label: 'Ready',
    icon: Check,
    className: 'bg-status-ready-bg text-status-ready border-status-ready'
  },
  processing: {
    label: 'Processing',
    icon: Clock,
    className: 'bg-status-processing-bg text-status-processing border-status-processing'
  },
  draft: {
    label: 'Draft',
    icon: FileText,
    className: 'bg-status-draft-bg text-status-draft border-status-draft'
  }
}

const StatusBadge = ({ 
  status, 
  label, 
  showIcon = false,
  size = 'default'
}: StatusBadgeProps) => {
  const config = statusConfig[status]
  const Icon = config.icon
  const displayLabel = label || config.label
  const sizeClass = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2.5 py-0.5'
  const iconSize = size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3'
  
  return (
    <Badge className={`${config.className} ${sizeClass}`}>
      {showIcon && <Icon className={`${iconSize} mr-1`} />}
      {displayLabel}
    </Badge>
  )
}

export default StatusBadge

